// src/components/sites/SiteDialog.jsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

export function SiteDialog({
  open,
  onClose,
  form,
  setForm,
  companies,
  onSubmit,
  isEditing,
}) {
  const validate = () => {
    if (!form.company) return "請輸入KMK子公司";
    if (!form.contractor) return "請輸入大判名稱";
    if (!form.job_code) return "請輸入Job Code";
    if (!form.name) return "請輸入地盤名稱";
    if (!form.address) return "請輸入地址";
    if (!form.site_status) return "請輸入施工狀態";
    return "";
  };

  const handleSave = async () => {
    const msg = validate();
    if (msg) {
      alert(msg);
      return;
    }
    await onSubmit();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{isEditing ? "修改地盤" : "新增地盤"}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="dense">
          <InputLabel>KMK子公司</InputLabel>
          <Select
            label="KMK子公司"
            value={form.company}
            onChange={(e) => setForm({ ...form, company: e.target.value })}
          >
            {companies.map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          fullWidth
          margin="dense"
          label="大判名稱"
          value={form.contractor}
          onChange={(e) => setForm({ ...form, contractor: e.target.value })}
        />
        <TextField
          fullWidth
          margin="dense"
          label="Job Code"
          value={form.job_code}
          onChange={(e) => setForm({ ...form, job_code: e.target.value })}
        />
        <TextField
          fullWidth
          margin="dense"
          label="地盤名稱"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
        <TextField
          fullWidth
          margin="dense"
          label="地址"
          value={form.address}
          onChange={(e) => setForm({ ...form, address: e.target.value })}
        />
        <FormControl fullWidth margin="dense">
          <InputLabel>施工狀態</InputLabel>
          <Select
            label="施工狀態"
            value={form.site_status}
            onChange={(e) =>
              setForm({ ...form, site_status: e.target.value })
            }
          >
            <MenuItem value="not_start">未動工</MenuItem>
            <MenuItem value="started">施工中</MenuItem>
            <MenuItem value="finished">完工</MenuItem>
            <MenuItem value="delivered">已交付</MenuItem>
          </Select>
        </FormControl>
        <TextField
          fullWidth
          margin="dense"
          label="備註(選填)"
          value={form.remark || ""}
          onChange={(e) => setForm({ ...form, remark: e.target.value })}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>取消</Button>
        <Button variant="contained" onClick={handleSave}>
          {isEditing ? "更改" : "新增"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
